import React, { useCallback, useRef } from "react";

//mui
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import Chip from "@mui/material/Chip";

//components
import CustomPopper from "./PopperComponent";

const Container = styled("div")(({ theme }) => ({
  // "& .MuiMenuItem-root": {
  //   // background: "green",
  // },
  "& .MuiAutocomplete-root": {
    background: "#FFFFFF",
  },
  "& .MuiAutocomplete-input": {
    height: "19px",
    fontSize: "14px",
    [theme.breakpoints.down("xl")]: {
      height: "17px",
      fontSize: "14px",
    },
  },
  "& .MuiInputLabel-root": {
    paddingBottom: "30px",
    fontSize: "15px",
    color: "#4F4F4F",
    [theme.breakpoints.down("xl")]: {
      fontSize: "14px",
    },
  },
  "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
    // paddingTop: "3px",
    // paddingBottom: "3px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    "& .MuiChip-root": {
      margin: theme.spacing(0.5),
    },
    "& .MuiChip-label": {
      fontSize: "12px",
      paddingTop: 0,
      paddingBottom: 0,
      // whiteSpace: "nowrap",
      // // width: 50px;
      // overflow: "hidden",
      // textOverflow: "ellipsis",
      [theme.breakpoints.down("xl")]: {
        fontSize: "11px",
      },
    },
    // "& .MuiSvgIcon-root": {
    //   fontSize: "18px",
    //   [theme.breakpoints.down('xl')]: {
    //     fontSize: "16px",
    //   },
    // },
    "& .MuiAutocomplete-tagSizeMedium": {
      fontSize: "14px",
      // background: "cyan",
      [theme.breakpoints.down("xl")]: {
        fontSize: "12px",
      },
    },
  },
  "& .MuiAutocomplete-root .MuiAutocomplete-tag": {
    padding: 0,
  },
}));

const AutoCompleteMultiUserSelect = ({
  options,
  value,
  variant = "outlined",
  onChange,
  disabled = false,
  label,
  limitTags,
  text,
  onInputChange,
  currentPage,
  pageCount,
  loadType,
  getUsersData,
  // project,
  // property,
  leftIcon,
  Outsidelabel = null,
  ...restProps
}) => {
  const Icon = leftIcon;
  const intObserver = useRef();
  const lastItemRef = useCallback(
    (post) => {
      if (intObserver.current) intObserver.current.disconnect();

      intObserver.current = new IntersectionObserver((posts) => {
        if (posts[0].isIntersecting && currentPage <= pageCount) {
          getUsersData("", currentPage);
        }
      });

      if (post) intObserver.current.observe(post);
    },
    [currentPage, pageCount]
  );

  let len = null;
  if (options && options.length > 0) {
    len = options.length;
  }

  return (
    <Container>
      {Outsidelabel}
      <FormControl variant="outlined" sx={{ width: "100%", padding: 0 }}>
        <Autocomplete
          multiple
          fullWidth
          options={options ? options : []}
          value={value}
          onInputChange={(event, val, reason) => {
            if (reason === "input" || reason === "clear") {
              onInputChange?.(event, val);
            }
          }}
          getOptionLabel={(option) =>
            option
              ? option?.role?.length === 1
                ? `${option.name} - (${option.role[0].name})`
                : option?.role.length === 2
                ? `${option.name} - (Admin)`
                : `${option.name}`
              : ""
          }
          onChange={(event, newValue) => onChange(newValue, text)}
          limitTags={limitTags}
          isOptionEqualToValue={(option, val) => option?.pk === val?.pk}
          filterSelectedOptions
          // renderTags={(value, getTagProps) =>
          //   value.map((option, index) => {
          //     return (
          //       <Chip label={option.name} {...getTagProps({ index })} />
          //     )
          //   })
          // }
          renderTags={(value, getTagProps) =>
            value.length > 1 ? (
              <Chip
                label={`${value[0].name} + ${value.length - 1}`}
                {...getTagProps(0)}
              />
            ) : (
              <Chip label={value[0].name} {...getTagProps(0)} />
            )
          }
          renderOption={(props, option) => {
            let ref = null;
            if (options && options.length > 0) {
              ref = option === options[len - 1] ? lastItemRef : null;
            }
            return (
              <li {...props} ref={ref}>
                {option
                  ? option?.role.length === 1
                    ? `${option.name} - (${option.role[0].name})`
                    : option?.role.length === 2
                    ? `${option.name} - (Admin)`
                    : `${option.name}`
                  : ""}
              </li>
            );
          }}
          renderInput={(params, index) => {
            const { InputProps, inputProps, ...renderProps } = params;
            // inputProps.disabled = disabled;
            // InputProps.endAdornment = disabled ? (
            //   <></>
            // ) : (
            //   InputProps.endAdornment
            // );
            return (
              <TextField
                key={index}
                {...renderProps}
                InputProps={{
                  ...InputProps,
                  startAdornment: leftIcon ? (
                    <>
                      <InputAdornment position="start">
                        <Icon />
                      </InputAdornment>
                      {InputProps.startAdornment}
                    </>
                  ) : (
                    <></>
                  ),
                }}
                inputProps={inputProps}
                label={label}
                // className={classes.input}
                variant={variant}
                {...restProps}
              />
            );
          }}
          PopperComponent={CustomPopper}
        />
      </FormControl>
    </Container>
  );
};

export default AutoCompleteMultiUserSelect;
